import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";

import AOS from "aos";
import Vuesax from "vuesax";
import CursorFx from '@luxdamore/vue-cursor-fx';

import "vuesax/dist/vuesax.css";
import "aos/dist/aos.css";
import "./main.scss"
import "@luxdamore/vue-cursor-fx/dist/CursorFx.css";

const IS_DEV = process.env.NODE_ENV === "development";
Vue.config.silent = !IS_DEV;
Vue.config.productionTip = IS_DEV;
Vue.config.ignoredElements = [/^ion-/];

Vue.use(
  CursorFx
);

Vue.use(Vuesax, {
  colors: {
    primary: '#362c68',
    success: 'rgb(45,211,111)',
    danger: 'rgb(235,68,90)',
    warning: 'rgb(255,196,9)',
    dark: 'rgb(34,36,40)'
  }
});

new Vue({
  created() {
    AOS.init();
  },
  router,
  // store,
  render: (h) => h(App),
}).$mount("#app");